import { Link } from 'react-router-dom';
import { latestUpdates } from '@/mocks/home';

const tagColors: Record<string, string> = {
  '51在线': 'bg-accent-100 text-accent-800',
  '吃瓜事件': 'bg-secondary-100 text-secondary-800',
  '黑料曝光': 'bg-foreground-100 text-foreground-800',
  '吃瓜大赛': 'bg-primary-100 text-primary-700',
  '热门大瓜': 'bg-primary-100 text-primary-700',
};

export default function LatestUpdates() {
  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8">
          {/* Latest Updates List */}
          <div className="lg:col-span-3">
            <div className="flex items-center gap-2 mb-6">
              <div className="w-2 h-2 rounded-full bg-primary-500 animate-pulse"></div>
              <h2 className="text-xl font-heading font-bold text-foreground-900">
                实时更新
              </h2>
              <span className="text-xs text-foreground-400">LIVE</span>
            </div>

            <div className="space-y-3">
              {latestUpdates.map((item, idx) => {
                const tagClass = tagColors[item.tag] || 'bg-background-200 text-foreground-600';

                return (
                  <Link
                    key={item.id}
                    to={`/category/${item.categorySlug}`}
                    className="flex items-center gap-4 p-4 rounded-xl bg-background-100 hover:bg-background-200/70 transition-colors cursor-pointer group"
                  >
                    <span className="text-xs font-bold text-foreground-300 w-5 text-right flex-shrink-0">
                      {String(idx + 1).padStart(2, '0')}
                    </span>
                    <span className={`px-2.5 py-0.5 rounded-full text-xs font-bold whitespace-nowrap flex-shrink-0 ${tagClass}`}>
                      {item.tag}
                    </span>
                    <span className="text-sm text-foreground-800 font-medium flex-1 group-hover:text-primary-600 transition-colors line-clamp-1">
                      {item.title}
                    </span>
                    <span className="text-xs text-foreground-400 flex-shrink-0 whitespace-nowrap">
                      {item.time}
                    </span>
                  </Link>
                );
              })}
              </div>
            </div>

            {/* Hot Tags Cloud */}
            <div className="lg:col-span-2">
              <h2 className="text-xl font-heading font-bold text-foreground-900 mb-6">
                热门标签
              </h2>
              <div className="bg-background-100 rounded-2xl p-6">
                <div className="flex flex-wrap gap-2">
                  {[
                    { label: '今日吃瓜', slug: 'remen-dagua' },
                    { label: '热门大瓜必看', slug: 'remen-dagua' },
                    { label: '黑料曝光', slug: 'expose' },
                    { label: '吃瓜大赛', slug: 'competition' },
                    { label: '51吃瓜入口', slug: '51online' },
                    { label: '独家爆料', slug: 'expose' },
                    { label: '吃瓜合集', slug: '51online' },
                    { label: '实时更新', slug: 'event' },
                    { label: '吃瓜事件', slug: 'event' },
                    { label: '51在线', slug: '51online' },
                    { label: '吃瓜网', slug: 'remen-dagua' },
                    { label: '每日吃瓜', slug: 'competition' },
                  ].map((tag) => (
                    <Link
                      key={tag.label}
                      to={`/category/${tag.slug}`}
                      className="px-4 py-2 rounded-full bg-background-50 text-foreground-600 text-xs font-medium hover:bg-secondary-100 hover:text-secondary-800 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {tag.label}
                    </Link>
                  ))}
                </div>
              </div>

              {/* Quick Stats */}
              <div className="mt-6 bg-primary-500 rounded-2xl p-6">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-10 h-10 rounded-full bg-background-50/20 flex items-center justify-center">
                    <i className="ri-flashlight-line text-background-50 text-lg w-5 h-5 flex items-center justify-center"></i>
                  </div>
                  <div>
                    <div className="text-background-50 font-bold text-lg">51在线入口</div>
                    <div className="text-background-50/70 text-xs">实时更新中</div>
                  </div>
                </div>
                <Link
                  to="/category/51online"
                  className="mt-4 block w-full py-2.5 rounded-lg bg-background-50 text-primary-600 text-sm font-bold text-center hover:bg-background-50/90 transition-colors cursor-pointer"
                >
                  立即访问入口
                </Link>
              </div>
            </div>
          </div>
        </div>
    </section>
  );
}
